/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Nav_RolesInputs */

const en_admin_nav_roles = /** @type {(inputs: Admin_Nav_RolesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Roles`)
};

const zh_admin_nav_roles = /** @type {(inputs: Admin_Nav_RolesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`角色`)
};

/**
* | output |
* | --- |
* | "Roles" |
*
* @param {Admin_Nav_RolesInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_nav_roles = /** @type {((inputs?: Admin_Nav_RolesInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Nav_RolesInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_nav_roles(inputs)
	return zh_admin_nav_roles(inputs)
});
export { admin_nav_roles as "admin.nav.roles" }